import { RouterItemType } from "@/app/module/router/index";
import { routersPageBilling } from "@/pages/billing/index";
import { routersPageCompany } from "@/pages/company/index";
import { routesPageErrorBoundary } from "@/pages/error-boundary/index";
import { routerPageHome } from "@/pages/home/index";
import { routerPageLoginToken } from "@/pages/login-token/index";
import { routerPageLogin } from "@/pages/login/index";
import { routerPageMobileExit } from "@/pages/mobile-exit/index";
import { routersPageProducts } from "@/pages/products/index";
import { routerPageProfile } from "@/pages/profile/index";
import { routerPageReferral } from "@/pages/referral/index";
import { routersPageServices } from "@/pages/services/index";
import { routersPageStore } from "@/pages/store/index";
import { routersPageSupport } from "@/pages/support/index";
import { routerPageSystemView } from "@/pages/system-view/index";
import { routerPageTermsAndConditions } from "@/pages/terms-and-conditions/index";
import { routerPageTrialConfirmed } from "@/pages/trial-confirmed/index";

export { PageErrorBoundary } from "@/pages/error-boundary/index";
export { routerPageRoot } from "@/pages/root/index";

export const routerItems: RouterItemType[] = [
  routerPageHome,
  routerPageProfile,
  routerPageReferral,
  routerPageSystemView,
  routerPageTermsAndConditions,
  routerPageTrialConfirmed,
  routerPageMobileExit,
  routerPageLogin,
  routerPageLoginToken,
  ...routersPageStore,
  ...routersPageSupport,
  ...routersPageBilling,
  ...routersPageCompany,
  ...routersPageServices,
  ...routersPageProducts,
  ...routesPageErrorBoundary,
];
